<template>
  <div class="app-container">
    <CrudTable ref="table" entity="Country" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import crudIndexMixin from '@/mixins/crud-index';
export default {
  components: {
    CrudTable
  },
  mixins: [crudIndexMixin],
  data() {
    return {
      columns: [{ field: 'code', width: 100 }, 'name']
    };
  }
};
</script>

<style scoped></style>
